/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SidebarComponent } from 'src/app/@amiga-pyme/class/sidebar.class';
import {
  CartPurchaseService,
  TypeAddCart
} from '../../utils-components/cart/cart-purchase.service';

@Component({
  selector: 'pg-product-of-provider-sidebar',
  templateUrl: './product-of-provider-sidebar.component.html',
  providers: [MessageService]
})
export class ProductSaleSidebarComponent extends SidebarComponent {
  @Input() type: TypeAddCart;
  itemStock: { label: string; value: string }[];
  settings = {
    title: null,
    tooltip: null
  };
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private cartPurchaseService: CartPurchaseService
  ) {
    super('Producto SideBar Stock');
  }

  ngOnInit() {
    this.setSettings();
    this.setItemInSideBar();
    const quantityCart = this.item?.quantityCart ? this.item.quantityCart : 0;
    const lot = this.item?.lot ? this.item.lot : '';
    const unitPrice = this.item?.unitPrice ? this.item.unitPrice : 0;
    const expDate = this.item?.expDate ? this.item.expDate : '';

    this.fg = this.fb.group({
      quantityCart: [quantityCart, [Validators.required, Validators.min(1)]],
      lot: [lot, [Validators.required]],
      unitPrice: [unitPrice, [Validators.required, Validators.min(0)]],
      expDate: [expDate, [Validators.required]]
    });
  }

  onSubmit() {
    if (this.fg.valid) {
      const newItem = {
        ...this.item,
        ...this.fg.value
      };
      this.addItemIntoCart$(newItem, this.type);
    }
  }

  setSettings() {
    this.settings = {
      title: 'Agregar Producto',
      tooltip: 'Agregar al almacén'
    };

    if (this.type === 'new') {
      this.settings = {
        title: 'Agregar Producto al Carrito',
        tooltip: 'Agregar al carrito'
      };
    } else if (this.type === 'update') {
      this.settings = {
        title: 'Actualizar Producto del Carrito',
        tooltip: 'Actualizar el carrito'
      };
    }
  }

  addItemIntoCart$(data: any, type: TypeAddCart) {
    if (!data) return;
    if (type === 'new') {
      this.addNewItemCart(data);
    } else if (type === 'update') {
      this.updateItemCart(data);
    }
  }

  addNewItemCart(item) {
    const id = item.id;
    const existsItem = this.cartPurchaseService.data[id];
    if (existsItem) {
      this.messageService.add({
        severity: 'warn',
        summary: 'El producto ya fue agregado',
        detail: 'Puedes modificar la cantidad en el carrito'
      });
      setTimeout(() => {
        this.close.emit();
      }, 2200);
      return;
    }
    this.cartPurchaseService.addItem(item);
    this.messageService.add({
      severity: 'success',
      summary: 'Producto Agregado',
      detail: `${item.description}--${item.unitMeasureDescription}`
    });
    setTimeout(() => {
      this.close.emit();
    }, 1200);
  }

  updateItemCart(item) {
    this.cartPurchaseService.addItem(item);
    this.messageService.add({
      severity: 'success',
      summary: 'Producto Actualizado',
      detail: item.itemCode + ' - ' + item.itemName
    });
    setTimeout(() => {
      this.close.emit();
    }, 1200);
  }

  setItemInSideBar() {
    const fieldsStock = {
      code: 'Código de producto',
      description: 'Descripción',
      providerRuc: 'RUC proveedor',
      providerName: 'Nombre del proveedor',
      unitMeasureDescription: 'Unidad de medida'
    };

    const keysStock = Object.keys(fieldsStock);
    this.itemStock = keysStock.map((key) => {
      return {
        label: fieldsStock[key],
        value: this.item[key]
      };
    });
  }
}
